module.exports = __webpack_public_path__ + "static/assets/744447c1979d53b8e22b4bca9ab799e5.svg";